import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {cloneDeep} from 'lodash'
import {formatProduct} from './utils'

export type IActiveBonus = {
  /** 折扣 */
  discount: string
  /** 金币 */
  coins: number
  tag: string
  /** 总金币数 */
  total_coin: number
}
export type IChannelItem = {
  /** 支付方式ID */
  pay_method_id: number
  /** 渠道名称 如： checkout */
  channel_name: string
  /** 子渠道名称 如：VISA */
  name: string
  /** 支付icon图标 */
  img?: string
  /** 上回支付成功 */
  last_succeed?: boolean
  /** 商品id	必须	 */
  product_id: string
  /**  商品价格，不需要做额外处理	必须	*/
  price: number
  /** 商品对应金币数	必须 */
  coins: number
  /** 货币单位	必须	“USD”: 美元 */
  currency: string
  /** 优惠价值 */
  discount_amount: string
  /** 排序分 */
  score: number
}

export type ICountry = {
  /** int64 国家代码 */
  code: number
  /** 国家名字 */
  name: string
}

export type IThirdPartyItem = {
  // /** 渠道折扣 */
  // discount: string
  /** 商品对应金币数 */
  coins: number
  /** 活动折扣信息	 */
  activity_bonus: IActiveBonus
  /** 该sku可用的支付渠道信息 */
  third_pay_list: IChannelItem[]

  /** h5 */
  channel: IChannelItem[]
}
export type IWebThirdPartyItem = {
  /** 商品对应金币数 */
  coins: number
  /** 活动折扣信息	 */
  activity_bonus: IActiveBonus

  channel_name: string
  currency: string
  /** 渠道折扣 */
  discount_amount: string
  payment_id: string
  price: number | string
  product_id: string
  /** 该sku可用的支付渠道信息 */
  channel: IChannelItem[]
  last_succeed: boolean
}

export type IProductsReq = {
  /** 国家代码 */
  country_code?: string | number
  /** 快捷支付展示场景 */
  from?: string
  /** 需要额外x金币	 */
  need_coins?: number
  is_quick: boolean
}
export type IOfficeChannelItem = {
  activity_bonus: any
  coins: number
  currency: string
  dt: number
  id: string
  out_code: string
  price: number
  product_id: string
  type: string
}
export type IProductsResp = {
  /** 是否可以查看币商列表 */
  can_show_agency_list: boolean
  list: IOfficeChannelItem[]
  coins: number
  /** 0.没充值过 1.充值过  */
  is_recharged: boolean
  third_party_list: IThirdPartyItem[]
  /** 国家列表 */
  countries: ICountry[]
  /** 默认国家 */
  default_country: ICountry
  huawei_list: any[]
  /** 是否是首充用户 */
  is_first_recharge: boolean
  /** chat业务充值额外奖励说明页地址 */
  extra_desc_url: string
  /** 是否是审核版本，如果是审核版本，需要屏蔽掉页面上的审核敏感内容 */
  is_audit_ver: boolean
  /** 是否弹反馈窗口 */
  show_feedback_popup: boolean
  /** 快捷弹窗场景文案 */
  desc: string
  /** 排序实验 */
  order_exp: boolean
}

export const query_order_h5 = createAsyncThunk(
  '/live/pay/query_order_h5',
  async (params: {order_id: string}, store: any) => {
    const resp = await http.post<{data: any}>(
      `/live/pay/query_order_h5`,
      {
        ...store.getState().env.deviceinfo,
        ...params,
      },
      {
        xcErrorToast: true,
      }
    )

    return resp.data.data
  }
)

export const get_products_list_v2 = createAsyncThunk(
  '/live/pay/get_products_list_v2',
  async (productsReq: IProductsReq, store: any) => {
    const resp = await http.post<{data: IProductsResp}>(
      `/live/pay/get_products_list_v2`,
      {
        ...store.getState().env.deviceinfo,
        ...productsReq,
      }
    )

    // // hack
    // if (typeof window === 'undefined') {
    //   resp.data.data.third_party_list = []
    // }
    return resp.data.data
  }
)

export type IProfileResp = {
  /** int64，金币余额 */
  diamonds: number
  recharge_agency_info: {
    /** 是否币商 */
    is_recharge_agency: boolean
    /** 是否公开金币余额  */
    is_coin_public: boolean
    /** 交易说明 */
    trade_remark: string
  }
}
/** /live/account/profile */
export const getProfile = createAsyncThunk(
  '/live/account/profile',
  async (params, store: any) => {
    const resp = await http.post<{data: IProfileResp}>(
      '/live/account/profile',
      {
        ...store.getState().env.deviceinfo,
      }
    )

    return resp.data.data
  }
)

const initialState: {
  curPage: string
  curProduct: IThirdPartyItem & IWebThirdPartyItem
  curChannel: IChannelItem & {tag: string; id: string}
  productList: (IThirdPartyItem & IWebThirdPartyItem)[]
  productListResp: IProductsResp
  curCountry: ICountry
  h_dt?: number
  account: IProfileResp
  isProductListFetched: boolean
} = {
  curPage: 'wallet',
  curProduct: {} as IThirdPartyItem & IWebThirdPartyItem,
  curChannel: {} as IChannelItem & {tag: string; id: string},
  productList: [],
  productListResp: {
    list: [],
    coins: 0,
    is_recharged: false,
    third_party_list: [],
    countries: [],
    default_country: {
      code: undefined,
      name: '',
    },
    huawei_list: [],
    is_first_recharge: false,
    extra_desc_url: '',
    is_audit_ver: false,
    show_feedback_popup: false,
    desc: '',
    can_show_agency_list: false,
    order_exp: false,
  },
  curCountry: {} as ICountry,
  h_dt: undefined,
  account: {
    diamonds: 0,
    recharge_agency_info: {
      is_recharge_agency: false,
      is_coin_public: false,
      trade_remark: '',
    },
  },
  isProductListFetched: false,
}

export const WalletAdvancedSlice = createSlice({
  name: 'WalletAdvanced',
  initialState,
  reducers: {
    setCurPage: (state, action) => {
      Object.assign(state, {curPage: action.payload})
    },
    setCurProduct: (state, action) => {
      // 同时重置channel信息
      Object.assign(state, {curProduct: action.payload})
    },
    setCurChannel: (state, action) => {
      Object.assign(state, {curChannel: action.payload})
    },
    setCurCountry: (state, action) => {
      Object.assign(state, {curCountry: action.payload})
    },
    setDt: (state, action) => {
      Object.assign(state, {h_dt: action.payload})
    },
  },
  extraReducers: (builder) => {
    builder.addCase(get_products_list_v2.fulfilled, (state, action) => {
      const resp = action.payload
      const {
        list,
        coins,
        is_recharged,
        third_party_list,
        countries,
        default_country,
        huawei_list,
        is_first_recharge,
        extra_desc_url,
        is_audit_ver,
        show_feedback_popup,
        desc,
        can_show_agency_list,
        order_exp,
      } = resp
      Object.assign(state, {
        productListResp: {
          list,
          coins,
          is_recharged,
          third_party_list,
          countries,
          default_country,
          huawei_list,
          is_first_recharge,
          extra_desc_url,
          is_audit_ver,
          show_feedback_popup,
          desc,
          can_show_agency_list,
          order_exp,
        },
        isProductListFetched: true,
      })
      const formatList = cloneDeep(formatProduct(resp, state.h_dt))
      Object.assign(state, {productList: formatList})
    })

    builder.addCase(getProfile.fulfilled, (state, action) => {
      const {diamonds, recharge_agency_info} = action.payload
      Object.assign(state.account, {
        diamonds,
        recharge_agency_info,
      })
    })
  },
})

export default WalletAdvancedSlice.reducer

export const WalletAdvancedActions = WalletAdvancedSlice.actions
export const useWalletAdvancedState = () => {
  const data = useSelector((state) => {
    return state.WalletAdvanced
  })
  return data
}
